import toPairs from 'lodash/fp/toPairs'
import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import * as App from '../../../app/types'
import * as FlashMessage from '../../../components/flash-message';
import * as Help from '../../../components/help'
import * as Image from '../../../components/image'
import * as RasaInput from '../../../components/rasa-input'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'

interface DispatchProps {
  openModal: Image.OpenModalActionCreator,
  selectedPartner: string,
  updateHeaderUrl: NewsbriefTypes.StateUpdateActionCreator,
}
type Props = DispatchProps & NewsbriefTypes.WrappedConfigurationRows

export const Logo = ({selectedPartner, rows, openModal, updateHeaderUrl}: Props) => {
  const currentHeaderUrl = NewsbriefUtils.findConfig(Constants.HEADER_URL, selectedPartner, rows)
  const currentImageUrl = NewsbriefUtils.findConfig(Constants.HEADER_IMAGE_URL, selectedPartner, rows)
  return (
    <div>
      {currentImageUrl && !isEmpty(currentImageUrl.data.value) ?
        <div className="logo-container">
          <Row>
            <Col sm="2">
              <Button className="add-color" title="Edit logo"
                  onClick={() => openModal(selectedPartner, currentImageUrl.rowId)}>
                CHANGE LOGO
              </Button>
              <Help.Help id="banner-upload-help" helpType={'banner-upload-help'} />
            </Col>
            <Col>
              <img src={currentImageUrl.data.value} />
            </Col>
          </Row>
          <Row>
            <Col>
              <RasaInput.RasaInput label="Add Link URL "
                            placeholder="Enter a valid URL."
                            validation={RasaInput.validateOptionalUrl(
                              currentHeaderUrl ? currentHeaderUrl.data.value : '')}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateHeaderUrl({
                              name: Constants.HEADER_URL,
                              partnerCode: selectedPartner,
                              property: 'value',
                              rowId: currentHeaderUrl ? currentHeaderUrl.data.id.toString() : '',
                              value: e.target.value,
                            })}
                            value={currentHeaderUrl ? currentHeaderUrl.data.value : ''} />
            </Col>
          </Row>
       </div>
      :
       <Button className="add-color"
               onClick={() => openModal(selectedPartner, '')}
               title="Upload Image">
        Upload Image
      </Button>}
      <UploadLogoModalConnected helpText={Constants.LOGO_UPLOAD_HELP_TEXT} title="Select Logo Image"/>
    </div>
  )
}
export const LogoConnected = connect(
  ({ newsbriefConfigs }: NewsbriefTypes.WrappedState) => ({
    rows:
      toPairs(newsbriefConfigs.logo.data)
        .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
          ({rowId, data, editing}))
        .filter(({rowId, data, editing}) =>
          data.is_active &&
          NewsbriefUtils.isSelectedPartner(data.partner_code, newsbriefConfigs.configState.selectedPartner)),
    selectedPartner: newsbriefConfigs.configState.selectedPartner,
  }),
  {
    closeModal: Actions.closeModal,
    openModal: Image.openModal(Constants.LOGO_IMPORT),
    updateHeaderUrl: Actions.updateHeaderUrl,
  },
)(Logo)

const UploadLogoModalConnected = connect(
  ({ app, newsbriefConfigs }: App.WrappedState & NewsbriefTypes.WrappedState, helpProps: Image.HelpProps) =>
    ({
      ...helpProps,
      app,
      modal: newsbriefConfigs.logo.modal,
    }),
  {
    closeModal: Actions.closeModal,
    flashMessage: FlashMessage.showFlashError,
    submitModal: Image.uploadImage(Constants.LOGO_IMPORT),
    updateModal: Actions.updateLogoModalField,
  },
)
(Image.ImageUploadModal)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/logo/component.tsx